import CrossCircleIcon from "@atlaskit/icon/glyph/cross-circle";
import dayjs from "dayjs";
import React from "react";
import { Blocker } from "./Blockers";

export const getTableRows = (
    blockers: Blocker[],
    onDelete: (id: number) => void
) =>
    blockers.map((blocker, index) => {
        const rows = {
            key: `row-${index}-${blocker.id}`,
            cells: [
                {
                    key: "blocker.blockerName",
                    content: blocker.blockerName,
                },
                {
                    key: "start",
                    content: dayjs
                        .unix(
                            parseInt(
                                blocker.startDateTime as unknown as string,
                                10
                            )
                        )
                        .format("HH:mm DD.MM.YYYY"),
                },
                {
                    key: "end",
                    content: dayjs
                        .unix(
                            parseInt(
                                blocker.endDateTime as unknown as string,
                                10
                            )
                        )
                        .format("HH:mm DD.MM.YYYY"),
                },
                {
                    key: "cancel",
                    content: (
                        <div className="appointment-cancel">
                            <div
                                onClick={() => {
                                    onDelete(blocker.id);
                                }}
                            >
                                <CrossCircleIcon
                                    primaryColor="#FF5630"
                                    label=""
                                />
                            </div>
                        </div>
                    ) as unknown as string,
                },
            ],
        };

        return rows;
    });
